export default {
  "root": "_root_4fl0e_1",
  "input": "_input_4fl0e_1",
  "input--placeholder": "_input--placeholder_4fl0e_1",
  "slot": "_slot_4fl0e_1",
  "arrow": "_arrow_4fl0e_1",
  "--size-small": "_--size-small_4fl0e_1",
  "--size-medium": "_--size-medium_4fl0e_1",
  "--size-large": "_--size-large_4fl0e_1",
  "--size-xlarge": "_--size-xlarge_4fl0e_1",
  "--variant-faded": "_--variant-faded_4fl0e_1",
  "--variant-headless": "_--variant-headless_4fl0e_1",
  "--status-error": "_--status-error_4fl0e_1",
  "--disabled": "_--disabled_4fl0e_1",
  "--size-small--m": "_--size-small--m_4fl0e_1",
  "--size-medium--m": "_--size-medium--m_4fl0e_1",
  "--size-large--m": "_--size-large--m_4fl0e_1",
  "--size-xlarge--m": "_--size-xlarge--m_4fl0e_1",
  "--size-small--l": "_--size-small--l_4fl0e_1",
  "--size-medium--l": "_--size-medium--l_4fl0e_1",
  "--size-large--l": "_--size-large--l_4fl0e_1",
  "--size-xlarge--l": "_--size-xlarge--l_4fl0e_1",
  "--size-small--xl": "_--size-small--xl_4fl0e_1",
  "--size-medium--xl": "_--size-medium--xl_4fl0e_1",
  "--size-large--xl": "_--size-large--xl_4fl0e_1",
  "--size-xlarge--xl": "_--size-xlarge--xl_4fl0e_1"
};import "ni:sha-256;r0mdOJN_RXb9zT2HIQtNa-A3qW-rupIuHnADMpqOskA";